import { Router } from '@angular/router';
import { Component, Input, ViewChild, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { merge } from 'rxjs';
import { IOrganization, IContactDetail } from '@ahryman40k/ts-fhir-types/lib/R4';

@Component({
  selector: 'inc-organization-table',
  templateUrl: './organization-table.component.html',
  styleUrls: ['./organization-table.component.scss'],
})

export class OrganizationTableComponent implements AfterViewInit, OnChanges {
  @Input() organizationList: IOrganization[];
  @Input() contactPArray: IContactDetail[] = [];
  @Input() headOfInstArray: IContactDetail[] = [];
  @Input() filtered: boolean;
  @Input() actPage: number;
  @Input() pageSize: number;

  /* @Output() modifyOrgStatus = new EventEmitter<any>(); */
  @Output() callSortSizeChanged = new EventEmitter<{ pageSize: number, sort: { active: string, direction: string }, pageIndex: number }>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() displayedColumns: string[] = ['nameText', 'headOfInstitution', 'contactPName', 'status', 'more'];
  dataSource: MatTableDataSource<IOrganization> = new MatTableDataSource<IOrganization>();
  dataLength: any = 6;

  constructor(private router: Router) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.organizationList) {
      this.paginator.pageIndex = this.actPage;
      if (this.paginator.pageIndex === 0) {
        this.paginator.length = this.pageSize;
      }
      if (changes.organizationList.currentValue.length > this.pageSize) {
        this.dataSource.data = changes.organizationList.currentValue.slice(0, changes.organizationList.currentValue.length - 1);
        this.paginator.length += this.pageSize;
      } else {
        this.dataSource.data = changes.organizationList.currentValue;
      }
    }
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page).subscribe((data: any) => {
      if (data && data.pageSize) {
        this.callSortSizeChanged.emit({
          pageSize: data.pageSize,
          sort: { active: this.sort.active, direction: this.sort.direction },
          pageIndex: data.pageIndex
        });
      }
      if (data && data.active) {
        this.callSortSizeChanged.emit({
          pageSize: this.paginator.pageSize,
          sort: { active: data.active, direction: data.direction },
          pageIndex: data.pageIndex
        });
      }
    });
  }

  stopProp(event: Event) {
    event.stopPropagation();
  }

  navigateTo(url: string, organization: any) {
    localStorage.removeItem('org');
    this.router.navigateByUrl(url, { state: { parameter: organization } });
  }

  /* modifyStatus(org: IOrganization) {
    this.modifyOrgStatus.emit(org);
  } */

}
